import { makeStyles } from '@material-ui/core'

export const useStyle = makeStyles((theme) => ({
  layoutCards: {
    padding: 40,
    width: 1016,
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(19, 45, 74, 0.04) !important',
    marginTop: '0 !important',
    height: 'auto',
    [theme.breakpoints.down('sm')]: {
      padding: 40,
      height: '100%',
      boxShadow: 'none',
    },
  },
  container: {
    marginTop: 24,
  },
  newDate: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  oldDate: {
    margin: '24px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textOldDate: {
    paddingRight: 55,
  },
  iconEvent: {
    marginRight: 19,
    color: theme.palette.primary.dark,
  },
  dateOldDate: {
    color: theme.palette.error.dark,
  },
  dividerTop: {
    border: `1px solid ${theme.palette.common.white}`,
    borderBottomColor: theme.palette.secondary.light,
    width: 200,
    margin: 'auto',
    paddingTop: 24,
  },
  dividerBottom: {
    border: `1px solid ${theme.palette.common.white}`,
    borderTopColor: theme.palette.secondary.light,
    width: 200,
    margin: 'auto',
    paddingTop: 24,
  },
}))
